import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../slice/authSlice";
import LoginMiddleware from "../middleware/LoginMiddleware";
import userReducer from "../slice/UserSlice";
import areaReducer from "../slice/AreaSlice";
import planReducer from "../slice/PlanSlice";
import staffReducer from "../slice/StaffSlice";
import customerReducer from "../slice/CustomerSlice";
import complaintReducer from "../slice/ComplaintSlice";
import collectionReducer from "../slice/CollectionSlice";
import groupDataReducer from "../slice/GroupDataSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userReducer,
    areas: areaReducer,
    plans: planReducer,
    staff: staffReducer,
    customers: customerReducer,
    complaints: complaintReducer,
    collections: collectionReducer,
    groupData: groupDataReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(LoginMiddleware),
});

export default store;
